<template>
  <DefaultLayout>
    <template v-if="privacyLinkHref" #footer-links>
      |
      <a
        v-if="privacyLinkIsExternal"
        :href="privacyLinkHref"
        target="_blank"
        rel="noopener noreferrer"
        class="text-caption text-decoration-none"
      >{{ translate('parcours.layout.appLayout.privacy') }}</a>
      <RouterLink
        v-else
        :to="privacyLinkHref"
        class="text-caption text-decoration-none"
      >{{ translate('parcours.layout.appLayout.privacy') }}</RouterLink>
    </template>
  </DefaultLayout>
  <InitializationWizard />
  <ConsentModal />
</template>

<script setup lang="ts">
import { DefaultLayout, ConsentModal, usePrivacyConfig } from '@fondationcss/ui';
import { RouterLink } from 'vue-router';
import { translate } from '@fondationcss/sdk';
import InitializationWizard from '@/components/initialization-wizard.vue';

const { privacyLinkHref, privacyLinkIsExternal } = usePrivacyConfig();
</script>
